import React from 'react';
import ProgramTypeForm from '../ProgramTypeForm';

import './programTypeCreate.css';

export function ProgramTypeCreate() {
    return <ProgramTypeForm isEdit={false} />;
}
